import React, { useCallback, useContext, useEffect, useState } from "react";
import moment from "moment";
import "../../styles/main.css";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";
const Countdown = ({ launchDate }) => {
  const [countdownDate, setCountdownDate] = useState(
    new Date(launchDate).getTime()
  );
  const [state, setState] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const { language } = useContext(LanguageContext);
  const setNewTime = useCallback(() => {
    if (countdownDate) {
      const currentTime = new Date().getTime();

      const distanceToDate = countdownDate - currentTime;

      let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
      let hours = Math.floor(
        (distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      let minutes = Math.floor(
        (distanceToDate % (1000 * 60 * 60)) / (1000 * 60)
      );
      let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

      const numbersToAddZeroTo = [1, 2, 3, 4, 5, 6, 7, 8, 9];

      days = `${days}`;
      if (numbersToAddZeroTo.includes(hours)) {
        hours = `0${hours}`;
      }
      if (numbersToAddZeroTo.includes(minutes)) {
        minutes = `0${minutes}`;
      }
      if (numbersToAddZeroTo.includes(seconds)) {
        seconds = `0${seconds}`;
      }

      setState({ days: days, hours: hours, minutes, seconds });
    }
  }, [countdownDate]);
  useEffect(() => {
    const interval = setInterval(setNewTime, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [setNewTime]);

  return (
    <div
      className="module countdown_timer countdown_timer_0 bg_layout_light"
      data-end-timestamp="1621575360"
    >
      <div className="countdown_timer_container clearfix">
        {/* <h4 className="title">Launching Soon</h4> */}
        <div
          className="countdown_timer_section"
          style={{
            minWidth: 400,
            width: "100%",
            margin: "auto",
            textAlign: "center",
          }}
        >
          <div
            className="days section values"
            data-short="Day"
            data-full="Day(s)"
          >
            <p className="value">{state.days || "0"}</p>
            <p className="label">{TEXT[language]["TIMER"]["0"]}</p>
          </div>
          <div className="sep section">
            <p>:</p>
          </div>
          <div
            className="hours section values"
            data-short="Hrs"
            data-full="Hour(s)"
          >
            <p className="value">{state.hours || "00"}</p>
            <p className="label">{TEXT[language]["TIMER"]["1"]}</p>
          </div>
          <div className="sep section">
            <p>:</p>
          </div>
          <div
            className="minutes section values"
            data-short="Min"
            data-full="Minute(s)"
          >
            <p className="value">{state.minutes || "00"}</p>
            <p className="label">{TEXT[language]["TIMER"]["2"]}</p>
          </div>
          <div className="sep section">
            <p>:</p>
          </div>
          <div
            className="seconds section values"
            data-short="Sec"
            data-full="Second(s)"
          >
            <p className="value">{state.seconds || "00"}</p>
            <p className="label">{TEXT[language]["TIMER"]["3"]}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
